const devConfig = {
    host: "https://ol91fe64a0.execute-api.ap-northeast-1.amazonaws.com/prod",
    baseUrl: "/api"
};

export default devConfig;